import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import { useIsInModal } from '~/context/srp/FilterMenuContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import { CommonWrapper } from './FiltersMenu.styles';

export default function Cylinders() {
  const isInModal = useIsInModal();
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();

  return (
    <FilterDrawer
      testId="facet-cylinderCounts"
      facetContent={facetData.cylinderCounts?.buckets ?? []}
      facetName="Cylinders"
      borderless={isInModal}
    >
      <CommonWrapper>
        {facetData.cylinderCounts?.buckets?.map(
          ({ count, displayName, key }) => (
            <Checkbox
              checked={appliedFilters.cylinderCounts?.includes(key)}
              facet="cylinderCounts"
              filter={key}
              id={`cylinderCounts-${key}`}
              key={key}
              label={
                <span>
                  {showInventoryCounts
                    ? `${displayName} (${count.toLocaleString()})`
                    : displayName}
                </span>
              }
              onChange={() =>
                updateListFilter({
                  filterKey: 'cylinderCounts',
                  value: key
                })
              }
            />
          )
        )}
      </CommonWrapper>
    </FilterDrawer>
  );
}
